<template>
  <div class="chart-data-page-content common-title-page" id="spo2-page">
    <div class="title-wrapper title-wrapper-with-btn">
      <pods-input ref="podsInput"></pods-input>
      <span class="title">{{ $t('text.vital_signs') }}</span>
      <div
        class="light-blue-font inline-block live-wrapper pointer"
        @click="getData()"
      >
        <img class="mr-10" src="../../../assets/computer.svg" />
        <span class="bold-font">{{ $t('text.live').toUpperCase() }}</span>
      </div>
      <DatePicker />
    </div>
    <div class="spo2-content-wrapper" v-loading="loading">
      <div
        id="spo2-chart"
        class="mt-30"
        :style="{
          width: '100%',
          height: '300px'
        }"
      ></div>
      <div class="mt-30">
        <div>{{ $t('text.spo2') }}: {{ spo2Avg }}%</div>
        <div class="slider-wrapper">
          <el-slider
            v-model="spo2Data"
            range
            :marks="spo2Marks"
            disabled
            :min="0"
            :max="100"
          >
          </el-slider>
          <div
            class="avg-icon blackish-green-bg"
            :style="{
              left: spo2Avg / 100 > 1 ? '100%' : (spo2Avg / 100) * 100 + '%',
              marginLeft: spo2Avg / 100 > 0.95 ? '-20px' : ''
            }"
          ></div>
        </div>
      </div>
      <div class="mt-30">
        <div>{{ $t('text.heart_rate') }}: {{ heartRateAvg }}bpm</div>
        <div class="slider-wrapper">
          <el-slider
            v-model="heartRateData"
            range
            :marks="heartRateMarks"
            disabled
            :min="0"
            :max="200"
          >
          </el-slider>
          <div
            class="avg-icon blackish-green-bg"
            :style="{
              left:
                heartRateAvg / 200 > 1
                  ? '100%'
                  : (heartRateAvg / 200) * 100 + '%',
              marginLeft: heartRateAvg / 200 > 0.95 ? '-20px' : ''
            }"
          ></div>
        </div>
      </div>
      <div class="mt-30">
        <div>{{ $t('text.body_temperature') }}: {{ temperatureAvg }}C</div>
        <div class="slider-wrapper">
          <el-slider
            v-model="temperatureData"
            range
            :marks="temperatureMarks"
            disabled
            :min="0"
            :max="50"
          >
          </el-slider>
          <div
            class="avg-icon blackish-green-bg"
            :style="{
              left:
                temperatureAvg / 50 > 1
                  ? '100%'
                  : (temperatureAvg / 50) * 100 + '%',
              marginLeft: temperatureAvg / 50 > 0.95 ? '-20px' : ''
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PodsInput from '@/components/PodsInput'
import DatePicker from '@/components/DatePicker'
import $ from 'jquery'
import swal from 'sweetalert'
import ApiService from '@/services/ApiService.js'
import moment from 'moment-timezone'

export default {
  data() {
    return {
      chart: '',
      spo2Data: [90, 98],
      spo2Avg: 95,
      spo2Marks: {
        0: '0',
        25: '25',
        50: '50',
        75: '75',
        100: '100'
      },
      heartRateData: [50, 98],
      heartRateAvg: 70,
      heartRateMarks: {
        0: '0',
        50: '50',
        100: '100',
        150: '150',
        200: '200'
      },
      temperatureData: [35, 39],
      temperatureAvg: 37.6,
      temperatureMarks: {
        0: '0',
        20: '20',
        30: '30',
        40: '40',
        50: '50'
      },
      loading: false,
      source: []
    }
  },
  components: {
    PodsInput,
    DatePicker
  },
  mounted: function() {
    $('#spo2-chart').css('width', $('.el-tabs__content').width() + 'px')
    this.getData()
  },
  watch: {
    '$store.state.pods.selectedPod': function() {
      this.getData()
    },
    '$store.state.pods.selectedDate': function() {
      this.getData()
    },
    '$store.state.pods.selectedUtcOffset': function() {
      this.getData()
    }
  },
  methods: {
    getData() {
      if (!this.$store.state.pods.selectedPod.podId) return false
      this.loading = true
      ApiService.GetGroupedData(
        this.$store.state.pods.selectedPod.podId,
        this.$store.state.pods.selectedDate[0],
        this.$store.state.pods.selectedDate[1],
        moment.tz(this.$store.state.pods.selectedUtcOffset).utcOffset() / 60
      )
        .then(response => {
          let vm = this
          this.loading = false
          this.source = [['timeStampWithUtc', 'spo']]
          response.data.forEach(item => {
            vm.source.push([
              moment
                .utc(item.timeStamp)
                .tz(this.$store.state.pods.selectedUtcOffset)
                .format('YYYY-MM-DD HH:mm:ss'),
              item.spo
            ])
          })
          if (this.source.length <= 1) {
            this.source.push(['', 0])
          }
          this.initChart()
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    initChart() {
      var dom = document.getElementById('spo2-chart')
      this.chart = this.echarts.init(dom)
      this.chart.setOption({
        grid: {
          left: '3%',
          right: 20,
          bottom: '4%',
          top: '4%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'time',
            boundaryGap: false,
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              showMinLabel: true,
              showMaxLabel: true
            }
          }
        ],
        yAxis: {
          type: 'value',
          name: this.$t('text.spo2') + '\n' + '(%)',
          nameLocation: 'center',
          nameTextStyle: {
            color: '#333'
          },
          min: 0,
          max: 100,
          axisLine: {
            lineStyle: {
              color: 'rgba(215, 215, 215, 1)'
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: 'rgba(215, 215, 215, 1)'
            }
          },
          axisLabel: {
            color: '#333'
          }
        },
        dataset: {
          dimensions: ['timeStampWithUtc', 'spo'],
          source: this.source
        },
        series: [
          {
            type: 'line',
            symbol: 'none',
            encode: {
              x: 'timeStampWithUtc',
              y: 'spo'
            },
            lineStyle: {
              color: 'rgba(0, 166, 237, 1)',
              width: 1
            }
          }
        ]
      })
      let vm = this
      window.addEventListener('resize', function() {
        vm.chart.resize()
      })
    }
  },
  beforeDestroy() {
    this.chart.clear()
  }
}
</script>
